module.exports = __webpack_public_path__ + "static/img/2.deaa1e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/2.jpg
// module id = jPjf
// module chunks = 0